<template>
  <div class="acomodar ">
    <div class="container-fluid py-3 px-2 px-md-4 ">
      <div class="mb-2">
        <button class="btn btn-danger mx-2" @click="regresar">
          <i class="bi bi-skip-backward"></i>
        </button>
      </div>
      <div class="border border-1 rounded-3 p-3 mb-3 ">
        <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
          <i class="bi bi-person-vcard-fill display-4 text-primary"></i>
          <div>
            <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
              INFORMACION
            </p>
            <p class="mb-0 tituloResaltado fs-4 fw-bold">
              COMPLETA DEL USUARIO
            </p>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="row g-3 mb-3">
          

          <!-- ID DEL USUARIO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-person-badge fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">ID DEL USUARIO :</p>
                <label class="ms-2 tamaño" disabled>{{ info.idPostulante }}</label>
              </div>
            </div>
          </div>

          <!-- NOMBRES -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-person-badge fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">NOMBRES:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posNombre }}</label>
              </div>
            </div>
          </div>

          <!-- APELLIDO PATERNO -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-person fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">APELLIDO PATERNO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posApePaterno }}</label>
              </div>
            </div>
          </div>

          <!-- APELLIDO MATERNO -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-person fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">APELLIDO MATERNO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posApeMaterno }}</label>
              </div>
            </div>
          </div>

          <!-- TIPO DE DOCUMENTO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-file-earmark-text fs-4 text-warning"></i>
              <div>
                <p class="mb-0 ps-2 color">TIPO DOCUMENTO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desTipDocumento }}</label>
              </div>
            </div>
          </div>

          <!-- NÚMERO DOCUMENTO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-credit-card-2-front fs-4 text-warning"></i>
              <div>
                <p class="mb-0 ps-2 color">NÚMERO DOCUMENTO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posNroDocumento }}</label>
              </div>
            </div>
          </div>

          <!-- GÉNERO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-gender-ambiguous fs-4 text-purple"></i>
              <div>
                <p class="mb-0 ps-2 color">GÉNERO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desGenero }}</label>
              </div>
            </div>
          </div>

          <!-- FECHA NACIMIENTO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-calendar-event fs-4 text-success"></i>
              <div>
                <p class="mb-0 ps-2 color">FECHA NACIMIENTO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posFecNacimiento }}</label>
              </div>
            </div>
          </div>

          <!-- ESTADO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-flag fs-4 text-info"></i>
              <div>
                <p class="mb-0 ps-2 color">ESTADO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desEstado }}</label>
              </div>
            </div>
          </div>

          <!-- PAÍS -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-globe-americas fs-4 text-success"></i>
              <div>
                <p class="mb-0 ps-2 color">PAÍS:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desPais }}</label>
              </div>
            </div>
          </div>

          <!-- NACIONALIDAD -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-passport fs-4 text-warning"></i>
              <div>
                <p class="mb-0 ps-2 color">NACIONALIDAD:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desNacionalidad }}</label>
              </div>
            </div>
          </div>

          <!-- CORREO -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-envelope fs-4 text-danger"></i>
              <div>
                <p class="mb-0 ps-2 color">CORREO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posCorreo }}</label>
              </div>
            </div>
          </div>

          <!-- DIRECCIÓN -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-geo-alt fs-4 text-success"></i>
              <div>
                <p class="mb-0 ps-2 color">DIRECCIÓN:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posDireccion }}</label>
              </div>
            </div>
          </div>

          <!-- GRADO ACADÉMICO -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-mortarboard fs-4 text-purple"></i>
              <div>
                <p class="mb-0 ps-2 color">GRADO ACADÉMICO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.desGradoAcademico }}</label>
              </div>
            </div>
          </div>

           <!-- CANTIDAD DE HIJOS -->
          <div class="col-12 col-md-3">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-people fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">CANTIDAD HIJOS:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posCanHijos }}</label>
              </div>
            </div>
          </div>

          <!-- ADJUNTO -->
          <div class="col-12 col-md-6">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-paperclip fs-4 text-secondary"></i>
              <div>
                <p class="mb-0 ps-2 color">ADJUNTO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posAdjunto }}</label>
              </div>
            </div>
          </div>

         

          <!-- HIJOS MENORES -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-people-fill fs-4 text-info"></i>
              <div>
                <p class="mb-0 ps-2 color">HIJOS MENORES:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posHijosMen }}</label>
              </div>
            </div>
          </div>

          <!-- PERFIL PROFESIONAL -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-briefcase fs-4 text-dark"></i>
              <div>
                <p class="mb-0 ps-2 color">PERFIL PROFESIONAL:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posPerProfesional }}</label>
              </div>
            </div>
          </div>

          <!-- CELULAR -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-phone fs-4 text-success"></i>
              <div>
                <p class="mb-0 ps-2 color">CELULAR:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posTelefono }}</label>
              </div>
            </div>
          </div>

          <!-- TELÉFONO ADICIONAL -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-telephone fs-4 text-primary"></i>
              <div>
                <p class="mb-0 ps-2 color">TELÉFONO ADICIONAL:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posTelAdicional }}</label>
              </div>
            </div>
          </div>

          <!-- UBIGEO -->
          <div class="col-12 col-md-2">
            <div class="border rounded-3 px-3 py-2 bg-white shadow-sm h-100 d-flex align-items-center gap-2">
              <i class="bi bi-geo fs-4 text-danger"></i>
              <div>
                <p class="mb-0 ps-2 color">UBIGEO:</p>
                <label class="ms-2 tamaño" disabled>{{ info.posUbigeo }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "SolimanologUsuarioInfoComplete",

  data() {
    return {
      IdPostulante: "",
      info: [],
    };
  },
  mounted() {
    this.IdPostulante = this.$route.params.ides;
    this.axios
      .get(
        "Postulante/ObtenerPostulante/" + this.IdPostulante
      )
      .then((datos) => {
        this.info = datos.data;
        console.log(datos.data);
      });
  },

  methods: {
    regresar() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  /* margin-right: 0.5rem !important; */
  margin-top: 9px;
  margin-bottom: 9px;
  margin-left: 0.5%;
  margin-right: 0.5%;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}

.color {
  font-weight: 700;
  color: #002c5d;
  font-size: 0.65rem;
}

.titulo2 {
  color: #0080c8;
  text-decoration: underline;
}

.tamaño {
  font-size: 0.65rem;
}

.bg-solimano {
  background: #0080c8;
}
</style>